export default function HaileyExpandIco() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 8.25L16.5 3M16.5 3H12M16.5 3V7.5M8.25 11.25L3 16.5M3 16.5H7.5M3 16.5V12"
        stroke="#344054"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
